import PropTypes from 'prop-types'

import { getOrderIconAndLabel } from 'utils/Orders/getOrderIconAndLabel'
import { orderStates } from 'utils/resources'
import { formatTime } from 'utils/formatTime'
import { formatPriceDecimals } from 'utils/formatPriceDecimals'

const OrdersDesktop = ({ orders, onClickItem }) => {
  return (
    <div className="items">
      <div className="header">
        <ul className="header__menu">
          <li className="header__menu-item">Date</li>
          <li className="header__menu-item">Order #</li>
          <li className="header__menu-item">Status</li>
          <li className="header__menu-item">Amount</li>
          <li className="header__menu-item -hidden-md">Payment</li>
          <li className="header__menu-item -hidden-md">Customer</li>
        </ul>
      </div>
      <section className="item-list section orders">
        {orders?.map((order) => {
          const { icon, label } = getOrderIconAndLabel(order)
          const total = formatPriceDecimals(order?.total)

          return (
            <div
              className="item"
              onClick={onClickItem(order?.uuid)}
              role="button"
              key={order?.uuid}
            >
              <div className="row orders__order-item">
                <div className="item-info-wrapper">
                  {formatTime(order?.createdAt, 'MM/DD/YY, h:mm A')}
                </div>
                <div className="item-info-wrapper">
                  {order?.orderSubmissionResult?.orderNumber ?? 'unknown'}
                </div>
                <div className="item-info-wrapper orders__order-status">
                  <span
                    className={`item-info-wrapper__dot -dot-${order?.state}`}
                  ></span>
                  <span>{orderStates[order?.state] ?? 'unknown'}</span>
                </div>
                <div className="item-info-wrapper">{total}</div>
                <div className="item-info-wrapper -hidden-md">
                  <div className="payment-type-icon">
                    {icon}
                    <div className="payment-type-icon__label-container">
                      <span className="payment-type-icon__label">{label}</span>
                    </div>
                  </div>
                </div>
                <div className="item-info-wrapper -hidden-md">
                  <div className="customer-name">
                    {order?.userName ?? 'N/A'}
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </section>
    </div>
  )
}

OrdersDesktop.propTypes = {
  orders: PropTypes.array,
  onClickItem: PropTypes.func,
}

export default OrdersDesktop
